import { Box, Button, Grid, Typography } from '@mui/material';
import React, { useState } from 'react';
import { ReviewCard } from '../../Reviews';
import { OwnerProfile } from '../../../types/owner';

const OwnerProfileReviews = ({ owner }: { owner: OwnerProfile }) => {
    const [viewAll, setViewAll] = useState(false);
    const { reviews } = owner;

    const displayedReviews = viewAll ? reviews : reviews.slice(0, 6);

    if (displayedReviews.length === 0) return null;

    return (
        <section aria-labelledby='owner-profile-reviews-heading'>
            <Typography
                id='owner-profile-reviews-heading'
                variant='h2'
                sx={{ pb: 2 }}
            >
                Reviews
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Grid container spacing={1}>
                    {displayedReviews.map((review) => (
                        <Grid key={review.id} item xs={12} md={6} lg={4}>
                            <ReviewCard review={review} />
                        </Grid>
                    ))}
                </Grid>
                {reviews.length > 6 && (
                    <Button
                        variant='text'
                        color='primary'
                        onClick={() => setViewAll(!viewAll)}
                        sx={{ ml: 'auto' }}
                    >
                        Show {viewAll ? 'less' : 'more'} reviews
                    </Button>
                )}
            </Box>
        </section>
    );
};

export default OwnerProfileReviews;
